import * as moment from "moment";
import {JobEventApiDto, JobInvoicePathChangedEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {option, Option} from "ts-option";
import {JobInvoicePathLabelEnum} from "../JobInvoicePath";

/**
 * Job invoice path changed event.
 */
export default class JobInvoicePathChangedEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param {JobStatusEventData} data job invoice path change event data.
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobInvoicePathChangedEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobInvoicePathChangedEvent {
		const data = JobInvoicePathChangedEventData.fromJson(json.data as JobInvoicePathChangedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobInvoicePathChangedEvent(json.id, json.jobId, JobEventTypeEnum.InvoicePathChanged, entity,
			moment(json.createdAt), json.referenceNumber, data);
	}

	getIcon() {
		return Icon.Invoice;
	}

	getActivityType() {
		return "INVOICE PATH";
	}

	getActivityMessage(): string {
		const currentLabel = JobInvoicePathLabelEnum[this.data.current];
		const previousLabel = this.data.previous.map(p => JobInvoicePathLabelEnum[p]).getOrElse("EMPTY");
		return `Job invoice path changed from ${previousLabel} to ${currentLabel}`;
	}

}

export class JobInvoicePathChangedEventData {
	constructor(public readonly  previous: Option<string>, public readonly current: string) {}

	public static fromJson(json: JobInvoicePathChangedEventDataApiDto): JobInvoicePathChangedEventData {
		return new JobInvoicePathChangedEventData(option(json.previous), json.current);
	}
}
